function requestAdjustmentDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/request-adjustment/request-adjustment-dialog.html?$$REVISION$$'
  }
}

export { requestAdjustmentDialogDirective }
